import { Component } from '@angular/core';
import firebase from 'firebase';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the SearchPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-search',
  templateUrl: 'search.html',
})
export class SearchPage {
  public ideaList:Array<any>;
  public loadedIdeaList:Array<any>;
  public ideaRef:firebase.database.Reference;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.ideaRef = firebase.database().ref().child('ideas');

    this.ideaRef.on('value', ideaList => {
      let ideas = [];
      ideaList.forEach( idea => {
        ideas.push(idea.val());
        return false;
      });
    
      this.ideaList = ideas;
      this.loadedIdeaList = ideas;
    });

    
  }

  initializeItems(): void {
    this.ideaList = this.loadedIdeaList;
  }
  
  getItems(searchbar) {
    // Reset items back to all of the items
    this.initializeItems();
  
    // set q to the value of the searchbar
    var q = searchbar.srcElement.value;
  
  
    // if the value is an empty string don't filter the items
    if (!q) {
      return;
    }
  
    this.ideaList = this.ideaList.filter((v) => {
      if(v.title && q) {
        if (v.title.toLowerCase().indexOf(q.toLowerCase()) > -1) {
          return true;
        }
        return false;
      }
    });
  
    console.log(q, this.ideaList.length);
  
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SearchPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/search/search.ts